import {
  CARS_BOOKED_STATE_ASSIGNED,
  CARS_BOOKED_STATE_BLIND_PLUS,
  CARS_BOOKED_STATE_NOT_ASSIGNED,
  CARS_BOOKED_STATE_PENDING,
  isCarsBookedAssigned,
} from 'lib/carsBookedStates'

export const CARS_BOOKED_ROOT = 'cars-booked'

export const CARS_BOOKED_CAR_DETAILS = 'car-details'

const isPresentValue = (value) =>
  value !== null && value !== undefined && value !== ''

const toNumericValue = (value) => {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : null
}

export const hasCarsBookedBlindPlusChoice = (car) =>
  !!car?.isBlindSelection ||
  car?.choice === 'first' ||
  car?.assignedState === CARS_BOOKED_STATE_BLIND_PLUS ||
  isPresentValue(car?.blindPrice) ||
  !!car?.secondChoice

export const getCarsBookedDisplayedReprice = (car) =>
  isPresentValue(car?.blindPrice) ? car.blindPrice : car?.reprice

export const hasCarsBookedBlindMinusChoice = (car) => {
  const blindPrice = toNumericValue(getCarsBookedDisplayedReprice(car))
  const groupPrice = toNumericValue(car?.price)

  return blindPrice !== null && groupPrice !== null && blindPrice < groupPrice
}

export const hasCarsBookedBlindPositiveChoice = (car) =>
  hasCarsBookedBlindPlusChoice(car) && !hasCarsBookedBlindMinusChoice(car)

const getCarsBookedBlindChoiceKey = (car) =>
  hasCarsBookedBlindMinusChoice(car) ? 'blindMinus' : 'blindPlus'

export const getCarsBookedChoiceKey = (car) =>
  hasCarsBookedBlindPlusChoice(car)
    ? getCarsBookedBlindChoiceKey(car)
    : car?.firstChoice
    ? 'firstChoice'
    : 'secondChoice'

export const getCarsBookedUrl = (sessionId, partnerId, plate) => {
  const plateValue = plate ? `/${CARS_BOOKED_CAR_DETAILS}/${plate}` : ''

  return !sessionId || !partnerId
    ? `/${CARS_BOOKED_ROOT}`
    : `/${CARS_BOOKED_ROOT}/${sessionId}/${partnerId}${plateValue}`
}

export const getCarsBookedDisplayStatus = (car) =>
  car?.assignedState === CARS_BOOKED_STATE_PENDING
    ? CARS_BOOKED_STATE_PENDING
    : isCarsBookedAssigned(car)
    ? CARS_BOOKED_STATE_ASSIGNED
    : CARS_BOOKED_STATE_NOT_ASSIGNED

export const getCarsBookedStatusColor = (car) =>
  getCarsBookedDisplayStatus(car) === CARS_BOOKED_STATE_NOT_ASSIGNED
    ? 'error'
    : 'primary'

export const getCarsBookedRecapValues = (cars) => {
  const result = cars.reduce(
    (previous, car) => ({
      firstChoice: (previous.firstChoice || 0) + (car.firstChoice ? 1 : 0),
      secondChoice:
        (previous.secondChoice || 0) +
        (hasCarsBookedBlindPlusChoice(car) ? 1 : 0),
      blindPlus:
        (previous.blindPlus || 0) +
        (hasCarsBookedBlindPositiveChoice(car) ? 1 : 0),
      blindMinus:
        (previous.blindMinus || 0) +
        (hasCarsBookedBlindMinusChoice(car) ? 1 : 0),
      assigned:
        (previous.assigned || 0) +
        (getCarsBookedDisplayStatus(car) === CARS_BOOKED_STATE_ASSIGNED
          ? 1
          : 0),
      notAssigned:
        (previous.notAssigned || 0) +
        (getCarsBookedDisplayStatus(car) === CARS_BOOKED_STATE_NOT_ASSIGNED
          ? 1
          : 0),
      totalValue: (previous.totalValue || 0) + car.price,
      favorites: (previous.favorites || 0) + (car.favorite ? 1 : 0),
    }),
    {}
  )
  const totalCars = cars.length
  result.total = totalCars
  result.secondChoice = Math.min(result.secondChoice || 0, totalCars)
  result.blindPlus = Math.min(result.blindPlus || 0, totalCars)
  result.blindMinus = Math.min(result.blindMinus || 0, totalCars)

  return result
}
